// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"f69727ca","601":"49a54da9","666":"46e465be"}[chunkId] + ".chunk.js";
};